<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="用户名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.userName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="权限名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="权限资源路径">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.url"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button size="mini" type="primary" @click="addUserHandler()"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="editUserHandler(slotData.data.row)"
          >修改</el-button
        >
        <el-popconfirm
          style="margin-left: 10px"
          title="确定删除吗？"
          @confirm="handleDelete(slotData.data.row.id)"
        >
          <template #reference>
            <el-button type="danger" size="mini">删除</el-button>
          </template>
        </el-popconfirm>
      </template>
    </e-table>

    <el-dialog
      :title="formText"
      :visible.sync="dialogFormVisible"
      :before-close="formClear"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="绑定用户" prop="wlUserId">
          <el-select
            v-model="ruleForm.wlUserId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="userLoading"
            @change="wlUserIdchange"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds">
          <el-select
            v-model="ruleForm.roleIds"
            multiple
            placeholder="请选择角色"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, key) in roleIdsList"
              :key="key"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import { frontUserlist } from "@/api/management";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable },
  mixins: [listMixin],
  props: {},
  data() {
    return {
      deleteKey: "id",
      url: {
        list: "/wlFontRole/queryPageRoleUser",
        add: "/wlFontRole/saveFoneRoleUser",
        delete: "/wlFontRole/delRoleUser",
      },
      columns: [
        {
          field: "userName",
          label: "用户名称",
        },
        {
          field: "phone",
          label: "电话",
        },
        {
          field: "name",
          label: "权限名称",
        },
        {
          field: "url",
          label: "权限资源路径",
        },
        {
          width: 160,
          label: "编辑",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      formText: "",
      dialogFormVisible: false,
      ruleForm: {
        name: "",
        phone: "",
        wlUserId: "",
        roleIds: [],
      },
      userLoading: false,
      options: [],
      rules: {
        wlUserId: [
          { required: true, message: "请绑定用户", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号不正确", trigger: "blur" },
        ],
        roleIds: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个角色",
            trigger: "blur",
          },
        ],
      },
      roleIdsList: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    addUserHandler() {
      this.formText = "新增";
      this.dialogFormVisible = true;
      httpAction("/wlFontRole/queryList", {}, "post").then((res) => {
        if (res.code == 200) {
          this.roleIdsList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    remoteMethod(query) {
      this.userLoading = true;
      if (query) {
        frontUserlist({ name: query }).then((res) => {
          if (res.code == 200) {
            this.userLoading = false;
            this.options = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.options = [];
        this.userLoading = false;
      }
    },
    wlUserIdchange(val) {
      httpAction("/wlFontRole/queryUserRoles?wlUserId=" + val, {}, "get").then(
        (res) => {
          if (res.code == 200) {
            const data = this.options.find((item) => item.id == val);
            this.ruleForm.wlUserId = data.id;
            this.ruleForm.name = data.nickname;
            this.ruleForm.phone = data.phone;
            this.ruleForm.roleIds = [];
            res.data.forEach((item) => {
              this.ruleForm.roleIds.push(item.id);
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          httpAction(
            "/wlFontRole/saveFoneRoleUser",
            this.ruleForm,
            "post"
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('提交成功');
              this.formClear();
              this.loadData(1);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    formClear() {
      this.dialogFormVisible = false;
      this.options = [];
      this.ruleForm = {
        name: "",
        phone: "",
        wlUserId: "",
        roleIds: [],
      };
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },
    resetForm(formName) {
      this.options = [];
      this.ruleForm = {
        name: "",
        phone: "",
        wlUserId: "",
        roleIds: [],
      };
      this.roleIdsList = [];
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },
    editUserHandler(val) {
      // this.ruleForm = {};
      // this.$nextTick(() => {
      //   this.$refs["ruleForm"].clearValidate();
      // });
      // this.remoteMethod(val.userName);
      frontUserlist({ name: val.userName }).then((res) => {
        if (res.code == 200) {
          this.userLoading = false;
          this.options = res.data;
          this.wlUserIdchange(val.wlUserId);
        } else {
          this.$message.error(res.msg);
        }
      });
      this.formText = "编辑";
      this.dialogFormVisible = true;
      httpAction("/wlFontRole/queryList", {}, "post").then((res) => {
        if (res.code == 200) {
          this.roleIdsList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
    editOk() {
      this.loadData(1);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
